if (!customElements.get('collection-infinite-scroll')) {
  customElements.define(
    'collection-infinite-scroll',
    class CollectionInfiniteScroll extends HTMLElement {
      constructor() {
        super();
        this.loading = false;
        this.onIntersection = this.onIntersection.bind(this);
      }

      connectedCallback() {
        this.grid = document.getElementById('product-grid');
        this.spinner = this.querySelector('.loading__spinner');
        this.nextUrl = this.dataset.nextUrl;

        if (!this.grid || !this.nextUrl) return;

        this.observer = new IntersectionObserver(this.onIntersection, {
          // Only start loading once the customer actually scrolls down to the
          // last product, not several screens ahead of it.
          rootMargin: '0px',
        });
        this.observer.observe(this);
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
      }

      onIntersection(entries) {
        if (this.loading || !this.nextUrl) return;
        if (entries.some((entry) => entry.isIntersecting)) this.loadNextPage();
      }

      loadNextPage() {
        this.loading = true;
        if (this.spinner) this.spinner.classList.remove('hidden');

        const separator = this.nextUrl.includes('?') ? '&' : '?';
        const url = `${this.nextUrl}${separator}section_id=${this.dataset.sectionId}`;

        fetch(url)
          .then((response) => response.text())
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            this.appendProducts(html);
            this.updateNextUrl(html);
          })
          .catch((error) => {
            console.error('collection-infinite-scroll: failed to load the next page', error);
            this.stop();
          })
          .finally(() => {
            this.loading = false;
            if (this.spinner) this.spinner.classList.add('hidden');
          });
      }

      appendProducts(html) {
        const newGrid = html.getElementById('product-grid');
        if (!newGrid || !this.grid) return;

        const startIndex = this.grid.children.length;

        Array.from(newGrid.children).forEach((item, index) => {
          item.classList.remove('scroll-trigger--offscreen', 'scroll-trigger--cancel');
          if (item.hasAttribute('data-cascade')) {
            item.setAttribute('style', `--animation-order: ${startIndex + index + 1};`);
          }
          this.grid.appendChild(item);
        });

        if (typeof initializeScrollAnimationTrigger === 'function') {
          initializeScrollAnimationTrigger(this.grid);
        }
      }

      updateNextUrl(html) {
        const newControl = html.querySelector('collection-infinite-scroll');
        const nextUrl = newControl && newControl.dataset.nextUrl;

        if (nextUrl) {
          this.nextUrl = nextUrl;
        } else {
          this.stop();
        }
      }

      stop() {
        this.nextUrl = null;
        if (this.observer) this.observer.disconnect();
      }
    },
  );
}
